import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE_URL = `${u}/stock-profile`;

export async function getProfiles() {
  try {
    const res = await apiFetch(BASE_URL);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export async function updateProfile(symbol, payload) {
  try {
    const res = await apiFetch(`${BASE_URL}/symbol/${encodeURIComponent(symbol)}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

export async function refreshProfiles() {
  try {
    const res = await apiFetch(`${BASE_URL}/refresh`, { method: "POST" });
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}
